import { SVGProps } from 'react';

export const GiftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M14 8V13.5C14 14.0523 13.5523 14.5 13 14.5H3.5C2.94772 14.5 2.5 14.0523 2.5 13.5V8M8 3.75C8 2.7835 7.2165 2 6.25 2C5.2835 2 4.5 2.7835 4.5 3.75C4.5 4.7165 5.2835 5.5 6.25 5.5C6.73967 5.5 8 5.5 8 5.5M8 3.75C8 4.22683 8 5.5 8 5.5M8 3.75C8 2.7835 8.7835 2 9.75 2C10.7165 2 11.5 2.7835 11.5 3.75C11.5 4.7165 10.7165 5.5 9.75 5.5C9.26033 5.5 8 5.5 8 5.5M8 5.5V14.5M2.25 8H14.25C14.6642 8 15 7.66421 15 7.25V6.25C15 5.83579 14.6642 5.5 14.25 5.5H2.25C1.83579 5.5 1.5 5.83579 1.5 6.25V7.25C1.5 7.66421 1.83579 8 2.25 8Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
